<template>
  <WdsButtonIcon :title="$t('View contract details')" @click="handleContractClick">
    <WdsIcon name="document" :size="24" />
  </WdsButtonIcon>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonIcon, WdsIcon } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openContractDetailPanel } = useTablePanels()

const EmploymentContractColumn = graphql(`
  fragment EmploymentContractColumn on Employment {
    id
    hires {
      data {
        id
        latestContract {
          id
        }
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentContractColumn> }>()

const column = computed(() => useFragment(EmploymentContractColumn, props.row))

const handleContractClick = () => {
  // Get the first hire with a contract (most employments should have one hire)
  const hireWithContract = column.value.hires.data.find((hire) => hire.latestContract?.id)

  if (hireWithContract) {
    openContractDetailPanel({ hireId: hireWithContract.id })
  }
}
</script>
